import { StyledModalWrapper } from './styles';
import React from 'react';
import { ModalContent } from './components/modal-content';
import { QuickTermsAndConditionsProps } from 'components/termsAndConditions/types';

export const QuickTermsAndConditions = ({ handleChangeStep }: QuickTermsAndConditionsProps) => {
  return <StyledModalWrapper reverseAnimation={false} content={<ModalContent handleChangeStep={handleChangeStep} />} />;
};
